export default __webpack_public_path__ + "static/media/Bitmap.54098f9b.png";